import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';

export enum InfoPanelType {INFO = 'info', WARNING = 'warning', ERROR = 'error', SUCCESS = 'success'}

@Component({
  selector: 'greydom-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoPanelComponent {

  topic = input<string>('');
  message = input<string>('');
  messageCounter = input<number>(0);
  iconClickable = input<boolean>(false);
  messageToolTip = input<string>('');
  iconClick = output();

  additionalMessageIndicator = computed(()=>{
    const count = this.messageCounter();
    if (count > 9) return 'filter_9_plus';
    if (count > 1) return `filter_${count}`;
    return null;
  })
  context = computed(()=>{
    return this.getApplicationStatusContext(this.topic())
  })

  getApplicationStatusContext(status: string): InfoPanelType {
        switch (status?.toLowerCase()) {
        case 'accepted':
        case 'activated':
            return InfoPanelType.SUCCESS;
        case 'rejected':
        case 'suspended':
        case 'terminated':
        case 'ended':
            return InfoPanelType.ERROR;
        default:
            return InfoPanelType.WARNING;
        }
    }
}
